import store from '..'
import axios from 'axios'
import API from '@/common/api'
import regExp from '../../common/regExp'

// 태블릿 디바이스에서 tel링크 무효화 시키기 위한 isMobile check
const deviceType = () => {
  const ua = navigator.userAgent
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'tablet'
  } else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
    return 'mobile'
  }
  return 'desktop'
}

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getSmartVoice ({ state }, groupId) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-smart-voice',
          func: 'get-voices',
          siteid: siteInfo.site,
          groupId: groupId
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
    async getGroups ({ state }) {
      try {
        const siteInfo = store.state.authentication
        const res = await axios.post(`${API.BASE_URL}/castit/viewer`, {
          cmd: 'sc-smart-voice',
          func: 'get-groups',
          siteid: siteInfo.site
        })
        return res.data.message
      } catch (ex) {
        console.log(ex.response.data)
        return false
      }
    },
  },
  getters: {
  }
}
